import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { SVGIconModule } from '@progress/kendo-angular-icons';

@Component({
  selector: 'app-servicenow-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonsModule, LabelModule, InputsModule, SVGIconModule],
  templateUrl: './servicenow-form.component.html',
  styleUrls: ['./servicenow-form.component.scss']
})
export class ServiceNowFormComponent implements OnInit {
  @Input() loading: boolean = false;
  @Input() icons: Record<string, SVGIcon> = {};
  
  @Output() testConnection = new EventEmitter<void>();
  @Output() saveConfiguration = new EventEmitter<void>();

  serviceNowForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    // @longle - Initialize ServiceNow PSA form with validation
    this.serviceNowForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      instanceUrl: ['', [Validators.required, Validators.pattern('^https?:\\/\\/.+')]],
      supportsMultiTenant: [true, Validators.required]
    });
  }

  onTestConnection(): void {
    if (this.serviceNowForm.invalid) {
      this.serviceNowForm.markAllAsTouched();
      return;
    }
    this.testConnection.emit();
  }

  onSaveConfiguration(): void {
    if (this.serviceNowForm.invalid) {
      this.serviceNowForm.markAllAsTouched();
      return;
    }
    this.saveConfiguration.emit();
  }

  get formValue() {
    return this.serviceNowForm.value;
  }

  get isFormValid() {
    return this.serviceNowForm.valid;
  }
}
